// Per-section role guard + role-aware default landing.
//
// `RequireNav` wraps a top-nav section's routes: if the current role can't
// see that section it redirects to the role's landing page. `DefaultLanding`
// is used by the index / catch-all routes to send each role to its first
// visible section (e.g. `user` → /signals, others → /home).

import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { TopNavId } from '../layouts/navigation';
import { useAuth } from './AuthContext';
import { canSee, landingFor } from './roles';

export function RequireNav({
  nav,
  children,
}: {
  nav: TopNavId;
  children: ReactNode;
}) {
  const { role } = useAuth();
  if (!canSee(role, nav)) {
    return <Navigate to={landingFor(role)} replace />;
  }
  return <>{children}</>;
}

export function DefaultLanding() {
  const { role } = useAuth();
  return <Navigate to={landingFor(role)} replace />;
}
